import { ProgressBarGroup } from '@app/core/models';
import { StepperItem } from '../tracking';

export const getProgressGroupsFromStepperItems = (stepperItems: StepperItem[]): ProgressBarGroup[] => {
  const activeIndex = stepperItems.findIndex((s) => s.isActive);
  return stepperItems.reduce((acc: ProgressBarGroup[], _, currentIndex) => {
    acc.push({
      count: 1,
      current: currentIndex <= activeIndex ? 1 : 0,
    });
    return acc;
  }, []);
};
